<template>
  <div id="activity_d">
    <top></top>
    <div class="main">
      <div class="content">
        <p class="activity_d_title">查看活动</p>
        <div class="activity_d_border"></div>
        <div class="activity_d_form">
          <el-form
            :model="activityForm"
            ref="activityFormRef"
            :rules="activityFormRules"
            label-position="top"
          >
            <el-form-item label="活动分类" prop="activity_category">
              <el-input
                v-model="activityForm.activity_category"
                placeholder="请输入活动分类"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="活动名称" prop="activity_name">
              <el-input
                v-model="activityForm.activity_name"
                placeholder="请输入活动名称"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="活动地点" prop="activity_location">
              <el-input
                v-model="activityForm.activity_location"
                placeholder="请输入活动地点"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="开始时间" prop="activity_start_time">
              <el-input
                v-model="activityForm.activity_start_time"
                placeholder="请输入开始时间"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="结束时间" prop="activity_end_time">
              <el-input
                v-model="activityForm.activity_end_time"
                placeholder="请输入结束时间"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item
              label="品牌海报（最多五张）"
              prop="brand_poster"
              style="width: 100%"
            >
              <div class="activity_d_uploader">
                <multiple-image-upload
                  @handleUploading="handleUploading"
                  @handleUploadSuccess="handleUploadSuccess"
                  @handleDeleteImage="handleDeleteImage"
                  @handlePreviewImage="handlePreviewImage"
                  :imgSrcArray="activityForm.brand_poster"
                  :sizeLimit="500"
                ></multiple-image-upload>
              </div>
              <p class="activity_d_uploadTips">建议尺寸：1920 * 1080</p>
              <p class="activity_d_uploadTips">文件大小：≤ 500kb</p>
            </el-form-item>
            <el-form-item
              label="活动介绍（200字以内）"
              prop="activity_introduction"
              style="width: 100%"
            >
              <el-input
                type="textarea"
                :rows="6"
                placeholder="请输入展会介绍"
                v-model="activityForm.activity_introduction"
                maxlength="200"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="activity_d_button">
          <div class="declare_borderButton" @click="back">返回</div>
          <div class="declare_fillButton" @click="verifyForm">提交</div>
        </div>
      </div>
    </div>
    <maskLayer
      :show="maskLayerShow"
      :type="maskLayerType"
      :imgSrc="activityForm.brand_poster[previewImageIndex]"
      @handleCancelPreviewImage="handleCancelPreviewImage"
    ></maskLayer>
  </div>
</template>
  
<script>
import top from "../../components/top.vue";
import multipleImageUpload from "../../components/multipleImageUpload.vue";
import maskLayer from "../../components/maskLayer.vue";
import { getActivityDetail, modifyActivityDetail } from "../../api/api";
export default {
  name: "activityDetail",
  components: { top, multipleImageUpload, maskLayer },
  data() {
    return {
      activityId: "",
      maskLayerShow: false,
      maskLayerType: "",
      previewImageIndex: 0,
      activityForm: {
        activity_category: "",
        activity_name: "",
        activity_location: "",
        activity_start_time: "",
        activity_end_time: "",
        brand_poster: [],
        activity_introduction: "",
      },
      activityFormRules: {
        brand_poster: [
          { required: true, message: "请上传品牌海报", trigger: "change" },
        ],
        activity_introduction: [
          { required: true, message: "请填写展会介绍", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.activityId = this.$route.query.id;
    this.getDetail();
  },
  methods: {
    async getDetail() {
      let obj = {
        id: this.activityId,
      };
      const res = await getActivityDetail(this.$qs.stringify(obj));
      if (res.code == 1) {
        this.activityForm.activity_category = res.data.category;
        this.activityForm.activity_name = res.data.venue_name;
        this.activityForm.activity_location = res.data.location;
        this.activityForm.activity_start_time = res.data.start_time;
        this.activityForm.activity_end_time = res.data.end_time;
        this.activityForm.activity_introduction = res.data.description;
        if (typeof res.data.posters === "string") {
          let arr = [res.data.posters];
          this.activityForm.brand_poster = arr;
        } else if (
          typeof res.data.posters === "object" &&
          res.data.posters !== null &&
          res.data.posters !== undefined
        ) {
          this.activityForm.brand_poster = res.data.posters;
        }
      } else {
        this.$message.warning("获取活动详情失败！");
      }
    },
    verifyForm() {
      this.$refs["activityFormRef"].validate((valid, field) => {
        if (valid) {
          this.submitForm();
        } else {
          let arr = Object.keys(field);
          let tips = field[arr[0]][0].message;
          this.$message.error(tips);
          return false;
        }
      });
    },
    submitForm() {
      this.$confirm("确定要保存本次编辑结果吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let data = {
            id: this.activityId,
            posters: this.activityForm.brand_poster,
            description: this.activityForm.activity_introduction,
          };
          const res = await modifyActivityDetail(data);
          if (res.code == 1) {
            this.$message.success(res.msg);
            this.getDetail();
            this.$router.push({
              path: "/activityList",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    handleUploading() {
      this.maskLayerShow = true;
      this.maskLayerType = "upload";
    },
    handleUploadSuccess(src) {
      this.maskLayerShow = false;
      this.maskLayerType = "";
      if (src) {
        this.activityForm.brand_poster.push(src);
      }
    },
    handleDeleteImage(index) {
      this.activityForm.brand_poster.splice(index, 1);
    },
    handlePreviewImage(index) {
      this.maskLayerShow = true;
      this.maskLayerType = "preview";
      this.previewImageIndex = index;
    },
    handleCancelPreviewImage() {
      this.maskLayerShow = false;
      this.maskLayerType = "";
      this.previewImageIndex = 0;
    },
    back() {
      this.$router.push({
        path: "/activityList",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.activity_d_title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}
.activity_d_border {
  width: 100%;
  height: 5px;
  background-color: #f3f3f3;
  margin: 20px 0;
}
/deep/ .el-form {
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    width: 25%;
    margin-right: 2%;
    .el-textarea {
      width: 25%;
    }
    .activity_d_uploader {
      height: 160px;
    }
    .activity_d_uploadTips {
      font-size: 12px;
      color: #ff4d4f;
      font-weight: 600;
      line-height: 30px;
    }
  }
  .el-form-item:nth-child(3) {
    margin-right: 0;
  }
}
.activity_d_button {
  display: flex;
  width: 267px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 40px;
  justify-content: space-between;
  align-items: center;
}
</style>